import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setRegPage, currentWidget, setLoadingMass, popupOpenClose, setFailScreen } from '../../../../action/action'
import { getInncomRoomControlData, getSpeakerStatus, getTintControlData, restoreValue } from '../../../../action/roomControlAction'
import AcControl from './acControl'
import WindowTintControl from './WindowTintControl/index'
// import DemoAcControl from './demoAcControl'
import RoomTheme from "./RoomTheme"
// import DemoRoomTheme from "./demoRoomTheme"
// import SelectRoom from './selectRoom'
import SpeakerControl from './speakerControl'
import DemoSpeakerControl from '../demoSpeakerControl'
// import RoomThemeVersion2 from './roomControlInncom/roomThemeVersion2'
import { CMSPath, DEMO } from '../../../../config/constant'
import ErrorBoundary from '../../home/ErrorBoundry'
import SoundControl from './SpeakerSelect'
import { setGoHome, setLoader, setLoginRequired } from '../../../action/homeAction'
import { wipeGuestData } from '../../../../JS/wipeGuestData'
import { guestDetails } from '../../../../action/homeAction'
import { setRoomControlPage } from '../../../action/action'
import MultiController from './MultiController'


class InncomRoomControl extends Component {
    constructor(props) {
        super(props);
        this.time = 0;
        this.state = {
            loadingMass: false
        }
    }

    componentDidMount() {        
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room");

        console.log('this.props.guestDetail',this.props.guestDetail)
        if (SessionToken && (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken)) {
            if (this.props.currentWidgets.widgetType && !room || room === "null") {
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    this.props.setLoginRequired(true)
                } else {
                    this.props.setRegPage(true);
                }
                console.log("room", room);
            } else {
                console.log("there is some bug in guest registration flow.")
            }
        } else {
            //this.props.VDAStatusApi(SessionToken, this.props.guestDetail, this.VDAStatusCallBack);
            this.callStatusAPI(SessionToken);
        }
        this.props.guestDetails(SessionToken, wipeGuestData, this.props.guestDetail.guestToken);

    }

    callStatusAPI = (SessionToken) => {
        this.time = window.setTimeout(() => {
            if (this.state.loadingMass) {
                this.props.setLoadingMass(false);
                // this.props.popupOpenClose(true, "Currently no connection to room control.");
                this.setState({ loadingMass: false });
            }
        }, 3000);
        this.props.setLoadingMass(true);
        this.setState({ loadingMass: true });
        this.props.getInncomRoomControlData(SessionToken, this.props.guestDetail, this.CallbackRoomControlData, this);
        this.props.getTintControlData(this.props.guestDetail, (status) => {
        })
        // this.props.getSpeakerStatus("roomControl", this.props.guestDetail);
        //speakerInfoAPI(this.props.guestDetail, infoAction);
    }

    componentWillUnmount() {
        this.props.currentWidget({});
    }

    CallbackRoomControlData = (status, msg, thisRef) => {
        if (thisRef.state.loadingMass) {
            thisRef.props.setLoadingMass(false);
            window.clearTimeout(thisRef.time);
            thisRef.setState({ loadingMass: false });
            if (!status && !DEMO) {
                console.log('roomControl2');
                // thisRef.props.popupOpenClose(true, "Network Error.");
            } else {
                console.log("VDA status API success");
            }
        }

        if(!status){
            this.props.setFailScreen(true, msg, "We are not not able to get the data for room control, please check your internet connection or try again", true)
            this.props.setRoomControlPage("");
            this.props.setGoHome(true);
        }
    }

    getCurrentPage = () => {
       
        switch (this.props.currentPage) {
            case "Multi-Controller":
                return <MultiController/>;
            case 'AcControl':
                return (<AcControl />)
            case 'roomTheme':
                return (<RoomTheme />) //<DemoRoomTheme/>
            case 'speakerControl':
                 return (<SoundControl/>)
            case 'windowTintControl':
                return (<WindowTintControl/>)
            default:
                // return (<AcControl />)
        }
    }

    render() {
        return (
            <div class="main-container"
                // style={this.props.selectedZone.zoneId ?
                //     {
                //         backgroundImage: `url('${CMSPath}${this.props.currentWidgets.btnImageUrl}') center center no-repeat`,
                //         backgroundSize: "cover !important", backgroundAttachment: "fixed", height: "100%"
                    
                //     } :
                //     {
                //         background: `${this.props.menuColor.backgroundColor} center center no-repeat`,
                //         backgroundSize: "cover", backgroundAttachment: "fixed", height: "100vh"
                //     }
                // }

            >
                {this.getCurrentPage()}
                {console.log('this.props.hvac',this.props.hvac)}
                {console.log('this.props.lightScene',this.props.lightScene)}
                {console.log('this.props.curtain',this.props.curtain)}
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        currentPage: state.store2.roomControl.currentPage,
        guestDetail: state.store.home.guestDetails,
        currentWidgets: state.store.sideNavBar.currentWidget,
        hvac: state.store.InncomRoomControl.hvac,
        lightScene: state.store.InncomRoomControl.lightScene,
        curtain: state.store.InncomRoomControl.curtain,
        menuColor: state.store.home.MenuColor,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        seletedIndex: state.store.roomControl.seletedIndex,
        zoneCount: state.store.roomControl.zoneCount,
    }
}
export default connect(
    mapStateToProps,
    {
        setRegPage,
        getInncomRoomControlData,
        currentWidget,
        setLoadingMass,
        popupOpenClose,
        getSpeakerStatus,
        setLoginRequired,
        guestDetails,
        setRoomControlPage,
        setLoader,
        setGoHome,
        getTintControlData,
        setFailScreen,
        setRoomControlPage,
        restoreValue,


    }
)(InncomRoomControl);